import { gql, useMutation } from 'urql';

export interface SubmitFormManualInput {
  input: {
    eventId: number;
    submissionInfo: string;
    ticketSegmentId?: number | null;
  };
}

export interface SubmitFormManualResponse {
  submitFormManual: {
    __typename?: string;
  };
}

export const SUBMIT_FORM_MANUAL = gql`
  mutation SubmitFormManual($input: SubmitFormManualInput!) {
    submitFormManual(input: $input) {
      __typename
    }
  }
`;

export const useSubmitFormManual = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<SubmitFormManualResponse, SubmitFormManualInput>(
    SUBMIT_FORM_MANUAL
  );

  const submitFormManual = (variables: SubmitFormManualInput) => executeMutation(variables);

  return { data, error, fetching, submitFormManual };
};
